module.exports = __webpack_public_path__ + "static/img/logo.6bd3a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/vivia/logo.png
// module id = 6EAE
// module chunks = 0